var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6f3f2;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #002860;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button-Close",
    transform: "translate(-1697 -448)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    className: "cls-1",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1697 448)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18832",
    "data-name": "Group 18832",
    transform: "translate(1714.255 465.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    className: "cls-2",
    d: "M0,0V21.9",
    transform: "translate(15.489 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    className: "cls-2",
    d: "M0,0V21.9",
    transform: "translate(15.489 15.491) rotate(135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonClose);
export default __webpack_public_path__ + "static/media/Button-Close.4a1c3240258e843c9c3387c7a5d58a9a.svg";
export { ForwardRef as ReactComponent };